// Scrolls the element into view, centered in the viewport.
export const scrollToElement = (element: HTMLElement) => {
    if (typeof window === 'undefined') {
        return;
    }

    element?.scrollIntoView?.({
        behavior: 'smooth',
        block: 'center',
    });
};
